/* eslint-disable @typescript-eslint/ban-ts-comment */
import { defineStore } from 'pinia'
import { reactive, nextTick } from 'vue'
import {
  inspectUrl,
  TInspectUrlParams,
  TInspectUrlRes,
  IFile,
  getFileInfo,
  getFileInfoBatch,
} from '@remote/api/adapter/shell-mqtt'
// import { store } from '@remote/store'
import { IFile as IHeziFile } from '@remote/type/hezi'
import { getFileExtFormat } from '@remote/utils/file-helper'
import { previewFile } from '.'
import { toast } from '@remote/utils/dialog'

export const initData = {
  all: {} as { [path: string]: IHeziFile }, // 缓存文件
  files: [] as string[],
  visible: false,
  next_page_token: '',
  isLoading: false,
  requestId: 0,
  id: '',
  downloadPath: '',
  url: '',
  name: ' ',
  totalDownloaded: 0,
  totalFileNums: 0,
  isCompleted: false,
}

type TGetFilesApiParams = TInspectUrlParams

function toHeziFile (file: IFile): Partial<IHeziFile> {
  return {
    name: file.file_name.replace(/.*\//, ''),
    path: file.file_path,
    size: String(file.file_size),
    ext: getFileExtFormat(file.file_name),
    status: file.status,
    id: file.index,
    errno: file.errno,
    is_exist: file.is_exist,
  }
}

export async function getFilesApi (params: TGetFilesApiParams, requestId = 0): Promise<[TInspectUrlRes, number]> {
  const data = await inspectUrl(params)
  return [data, requestId]
}

export const useBTResult = defineStore('btResult', () => {
  const data = reactive(initData)
  const getFiles = async () => {
    data.requestId += 1
    data.isLoading = true
    const nextPageToken = data.next_page_token

    const [res, requestId] = await getFilesApi(
      {
        download_id: data.id,
        download_path: data.downloadPath,
        page_token: nextPageToken || '',
        url: data.url,
      },
      data.requestId,
    ).catch(err => {
      console.log('err', err)
      return []
    })
    console.log('getFilesApi', res)
    if (data.requestId !== requestId) return

    if (res?.ret) return toast({type: 'error', message: res.msg})

    if (res?.result?.files?.length) {
      const paths: string[] = []
      const files = res.result.files?.map((v) => {
        // @ts-ignore
        data.all[v.file_path] = toHeziFile(v)
        paths.push(v.file_path)
        return v.file_path
      })

      const nextFiles = nextPageToken ? data.files.concat(files) : files
      data.files = nextFiles
      data.next_page_token = res.result.page_token
      data.name = res?.result.name
      data.totalDownloaded = res?.result.total_downloaded
      data.totalFileNums = res?.result.total_file_nums
      console.log('this.next_page_token', data.next_page_token, nextPageToken)
      getFileInfoBatch(paths).then(res => {
        if (res?.result?.data?.length) {
          const nextAll = Object.assign({}, data.all)
          res?.result?.data?.forEach((v) => {
            nextAll[v.path] = Object.assign({}, data.all[v.path], v)
          })
          data.all = nextAll
        }
      }).finally(() => {
        data.isLoading = false
      })
    } else {
      data.next_page_token = ''
    }
  }

  const toggleVisibleBTResult = (visible: boolean, params: { dir: string; url: string; id: string; name:string }, isCompleted?:boolean) => {
    console.log('toggleVisibleBTResult 2')
    data.visible = visible
    data.isCompleted = !!isCompleted
    if (visible && params) {
      const { url, dir: downloadPath, id, name } = params
      data.url = url
      data.downloadPath = downloadPath
      data.id = id
      data.name = name
      return getFiles()
    } else {
      nextTick(() => {
        data.url = ''
        data.downloadPath = ''
        data.id = ''
        data.all = {}
        data.files = []
        data.name = ' '
        data.totalDownloaded = 0
        data.totalFileNums = 0
        data.next_page_token = ''
      })
    }
    return Promise.resolve()
  }

  return {
    data,
    toggleVisibleBTResult,
  }
})

export function toggleVisibleBTResult (visible: boolean, params: { dir: string; url: string; id: string; name:string }, isCompleted?:boolean) {
  const btResultStore = useBTResult()
  btResultStore.toggleVisibleBTResult(visible, params, isCompleted)
}

export function getFileInfoAndToPreview (path: string) {
  getFileInfo(path).then(res => {
    if (res?.result?.md5sum) {
      previewFile(res.result)
    }
  }).catch(err => {
    toast({type: 'error', message: err})
  })
}